export const GET_LIST_TRANSPORT_GROUP = "GET_LIST_TRANSPORT_GROUP";
export const GET_LIST_TRANSPORT_GROUP_SUCCESS =
  "GET_LIST_TRANSPORT_GROUP_SUCCESS";
export const GET_LIST_TRANSPORT_GROUP_ERROR = "GET_LIST_TRANSPORT_GROUP_ERROR";

// List CUSTOMER
export const getListTransportGroup = payload => ({
  type: GET_LIST_TRANSPORT_GROUP,
  payload,
});

export const getListTransportGroupSuccess = payload => {
  return {
    type: GET_LIST_TRANSPORT_GROUP_SUCCESS,
    payload,
  };
};

export const getListTransportGroupFail = error => {
  return {
    type: GET_LIST_TRANSPORT_GROUP_ERROR,
    error,
  };
};
